import { useMutation } from "@apollo/client";

import { SettingsResearchTypeListRoute_GetAllDocument } from "../../SettingsResearchTypeListRoute/queries.generated";
import { ResearchTypeCreateFormInputs } from "../components/ResearchTypeCreateForm";
import { SettingsResearchTypeCreateRoute_CreateDocument } from "../mutations.generated";

export default function useSettingsResearchTypeCreateRoute_Create() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeCreateRoute_CreateDocument, {
        refetchQueries: [SettingsResearchTypeListRoute_GetAllDocument],
    });

    const createResearchType = async (input: ResearchTypeCreateFormInputs) => {
        const result = await mutate({
            variables: {
                input,
            },
        });
        return result.data?.settingsResearchTypeCreate;
    };

    return {
        createResearchType,
        loading,
        error,
    };
}
